// extracted by mini-css-extract-plugin
export default {"containerPhone":"styles_containerPhone__q8hgb","phone":"styles_phone__D9vx9","text":"styles_text__68Upw","button":"styles_button__I8+Jh"};